import React from "react"
import SecondFloor from "./second/SecondFloor"
import ThirdFloor from "./third/ThirdFloor"
import { Wrapper } from "../../styled"

export default function PreBetFooter({
  footerState,
  stake,
  handleStake,
  handleAbove,
  handleClear,
  placeBet,
  handleNotification,
  // gameInfo,
  handleModal,
  audio,
}: any) {
  return (
    <Wrapper
      footerState={footerState === "placeBet" || footerState === "disabled"}
      height="160px"
    >
      <SecondFloor
        stake={stake}
        handleStake={handleStake}
        handleModal={handleModal}
        handleNotification={handleNotification}
        // gameInfo={gameInfo}
        audio={audio}
      />
      <ThirdFloor
        stake={stake}
        handleClear={handleClear}
        handleAbove={handleAbove}
        placeBet={placeBet}
        footerState={footerState}
        handleNotification={handleNotification}
        audio={audio}
        handleModal={handleModal}
      />
    </Wrapper>
  )
}
